module.exports = __webpack_public_path__ + "img/banner.44117b1b.png";